import { usePageTint } from "@/lib/pageTint";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { clearSharedSelection } from "@/components/Selection";
import { OwnerTwoFactorBanner } from "@/components/OwnerTwoFactorBanner";
import { Sidebar, MobileNav } from "@/components/Sidebar";
import { NavBar } from "@/components/NavBar";
import { PlayerBar } from "@/components/PlayerBar";
import { AudiobookSync } from "@/components/AudiobookControls";
import { ResumeSync } from "@/components/ResumeSync";
import { QueueDrawer } from "@/components/QueueDrawer";
import { RadioScheduler } from "@/components/radio/RadioScheduler";
import { GlobalSearch } from "@/components/GlobalSearch";
import { PlayerShortcuts } from "@/components/PlayerShortcuts";
import { useLibMode } from "@/hooks/useLibMode";
import { useAuth } from "@/context/AuthContext";
import { useScrollRestore } from "@/lib/restore";
import { setAutoUser, scheduleSync } from "@/lib/autoPins";
import { setThemesEnabled } from "@/lib/theme";
import { ThemeBackground } from "@/components/ThemeBackground";
import { useTheater } from "@/lib/theater";

export default function Layout() {
  const wash = usePageTint();
  const [queueOpen, setQueueOpen] = useState(false);
  const libMode = useLibMode();
  const { user } = useAuth();
  useScrollRestore();
  useEffect(() => { setAutoUser(user?.id); scheduleSync(3000); }, [user?.id]);
  useEffect(() => { setThemesEnabled(user?.themes_enabled !== false); }, [user?.themes_enabled]);
  const theater = useTheater();
  const { pathname } = useLocation();
  useEffect(() => { if (!/^\/(albums|artists?|album\/)/.test(pathname)) clearSharedSelection(); }, [pathname]);
  return (
    <div className={`min-h-screen bg-[#FAF9F6] text-zinc-900 ${theater ? "theater" : ""}`} data-theater={theater ? 1 : 0}>
      <ThemeBackground />
      {!theater && <Sidebar />}
      {!theater && <MobileNav />}
      <main className={`relative ${theater ? "" : "pb-32 md:pl-64"}`}>
        <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-[38rem] transition-opacity duration-700" data-testid="page-wash" data-tint={wash || ""}
          style={{ opacity: wash ? 1 : 0, background: wash ? `radial-gradient(55% 60% at 35% 0%, ${wash.replace("rgb(", "rgba(").replace(")", ",0.32)")}, transparent 70%)` : "none" }} />
        <div className="relative z-10">
          {!theater && <NavBar />}
          {!theater && <OwnerTwoFactorBanner />}
          <div className={theater ? "" : "mx-auto max-w-7xl px-5 pt-5 sm:px-10 sm:pt-7"}>
            <Outlet key={libMode} />
          </div>
        </div>
      </main>
      {!theater && <PlayerBar onQueue={() => setQueueOpen((o) => !o)} />}
      <AudiobookSync />
      <ResumeSync />
      <QueueDrawer open={queueOpen} onOpenChange={setQueueOpen} />
      <RadioScheduler />
      <GlobalSearch />
      <PlayerShortcuts />
    </div>
  );
}
